import './styles.scss'
import React, { useState, useEffect, useRef } from 'react'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import { useResizeHandler } from 'Utils/commonMethods'
import { COFFEE_COMMUNITIES_METHODS } from '../../CoffeeCommunities/Utils'

const EditMessageModal = (props) => {
  const { editModalVisible, setEditModalVisible, messageToEdit, onSave, formatTime } = props
  const { textMethods } = COFFEE_COMMUNITIES_METHODS
  const { isWebView } = useResizeHandler()

  const [editValue, setEditValue] = useState('')
  const [expanded, setExpanded] = useState(false)
  const editInputRef = useRef(null)
  const previewRef = useRef(null)

  // Initialize edit value when modal opens
  useEffect(() => {
    if (editModalVisible && messageToEdit) {
      setEditValue(messageToEdit?.content || messageToEdit?.attachments[0]?.caption || '')
    } else {
      setEditValue('')
    }
  }, [editModalVisible, messageToEdit])

  const handleEditChange = (newValue) => {
    setEditValue(newValue)

    if (editInputRef.current) {
      textMethods.autoResizeTextarea(editInputRef.current)
    }
  }

  const handleEditKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && editValue.trim()) {
      e.preventDefault()
      handleSave()
    }
  }

  const handleSave = () => {
    if (editValue.trim() && onSave) {
      onSave(editValue)
      setEditModalVisible(false)
      setEditValue('')
    }
  }

  const handleClose = () => {
    setEditModalVisible(false)
    setEditValue('')
  }

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 KB'

    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`

    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
  }

  const renderAttachmentData = () => {
    if (messageToEdit?.attachments[0]?.attachment_type === 'image') {
      return <img src={messageToEdit?.attachments[0]?.attachment_url} alt={messageToEdit?.attachments[0]?.file_name} className="edit-image" />
    }

    if (messageToEdit?.attachments[0]?.attachment_type === 'video') {
      return (
        <div className="video-wrapper">
          <video className="edit-video" controls={false}>
            <source src={messageToEdit?.attachments[0]?.attachment_url} />
          </video>
          <div className="play-pause-btn">
            <span className="pause-icon">▶</span>
          </div>
        </div>
      )
    }

    if (messageToEdit?.attachments[0]?.attachment_type === 'document') {
      return (
        <div className="document-wrapper">
          <i className="pi pi-file document-icon" />
          <div>
            <div className="document-name">{messageToEdit?.attachments[0]?.file_name}</div>
            <div className="document-size">{formatFileSize(messageToEdit?.attachments[0]?.file_size)}</div>
          </div>
        </div>
      )
    }
  }

  const renderEditModalBody = () => {
    if (!messageToEdit) return null

    return (
      <div className="edit-modal-content">
        <div className="content-wrapper">{renderAttachmentData()}</div>
        <div className={`message-preview${expanded ? ' expanded' : ''}`} ref={previewRef} onClick={() => setExpanded((prev) => !prev)}>
          <div>{messageToEdit.content || messageToEdit?.attachments[0]?.caption}</div>
          <div className="time">{formatTime(messageToEdit.timestamp)}</div>
        </div>
      </div>
    )
  }

  const renderEditModalFooter = () => (
    <div className="input-area">
      <div className="edit-container">
        <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="coffee-web-logo" className="input-logo" />
        <InputTextarea
          ref={(el) => {
            editInputRef.current = el
            if (el) {
              textMethods.autoResizeTextarea(el)
            }
          }}
          rows={isWebView ? 1 : 2}
          cols={1}
          value={editValue}
          onKeyDown={(e) => handleEditKeyDown(e)}
          onChange={(e) => handleEditChange(e.target.value)}
          placeholder="Type a message..."
          className="edit-input-field"
        />
      </div>
      <Button rounded icon="pi pi-send send-icon" disabled={!editValue.trim()} className={`send-button ${!editValue.trim() ? 'disabled-button' : ''} `} onClick={handleSave} />
    </div>
  )

  return <DialogUIModal title="Edit Message" showModal={editModalVisible} handleClose={handleClose} bodyContent={renderEditModalBody} footerContent={renderEditModalFooter} customClassName="edit-message-modal" contentWidth="38%" />
}

export default EditMessageModal
